import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Swipeable } from 'react-swipeable';
import s from './Duperswiper.scss';
const Duperswiper = ({ children , deviation , width , height , navigation: { nextItem , prevItem  } , isEnabled , moveNext , movePrev  })=>{
    const [xOffset, setOffset] = useState(0);
    const onSwipingLeft = useCallback((absX)=>{
        if (!nextItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(-absX);
    }, [
        nextItem,
        xOffset
    ]);
    const onSwipingRight = useCallback((absX)=>{
        // do nothing if there's nothing in the current direction
        if (!prevItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(absX);
    }, [
        prevItem,
        xOffset
    ]);
    const onSwiping = useCallback(({ dir , absX  })=>{
        switch(dir){
            case 'Left':
                onSwipingLeft(absX);
                return;
            case 'Right':
                onSwipingRight(absX);
                return;
            default:
        }
    }, [
        onSwipingLeft,
        onSwipingRight
    ]);
    const onSwipedLeft = useCallback(()=>{
        if (!nextItem) {
            setOffset(0);
            return;
        }
        setOffset(width ? -width : '-100%');
        moveNext();
    }, [
        moveNext,
        nextItem,
        width
    ]);
    const onSwipedRight = useCallback(()=>{
        if (!prevItem) {
            setOffset(0);
            return;
        }
        setOffset(width || '100%');
        movePrev();
    }, [
        movePrev,
        prevItem,
        width
    ]);
    if (!isEnabled) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children(deviation));
    }
    const transformStyle = {
        transform: `translateX(${xOffset}px)`
    };
    return /*#__PURE__*/ React.createElement(Swipeable, {
        trackMouse: true,
        onSwiping: onSwiping,
        onSwipedLeft: onSwipedLeft,
        onSwipedRight: onSwipedRight,
        className: s['swipeable']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: s['transform']
    }, children(deviation)), prevItem && xOffset > 0 && /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: classnames(s['preview'], s['prev'])
    }, children(prevItem)), nextItem && xOffset < 0 && /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: classnames(s['preview'], s['next'])
    }, children(nextItem))));
};
Duperswiper.displayName = 'Duperswiper';
export default Duperswiper;
